export default {"src":"/_next/static/media/error.f9e003ad.svg","height":80,"width":81,"blurWidth":0,"blurHeight":0};